export const PORTAL = {
  MERCHANT: 'merchant',
  MYDE: 'ims',
};
